import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    style: {
        "margin-top": "20px"
    }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_button = _resolveComponent("el-button");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_el_button_group = _resolveComponent("el-button-group");
    const _component_scTable = _resolveComponent("scTable");
    const _component_Dialog = _resolveComponent("Dialog");
    const _directive_loading = _resolveDirective("loading");
    return _openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
                type: "primary",
                onClick: $options.openSelect
            }, {
                default: _withCtx(()=>[
                        _createTextVNode(_toDisplayString($props.title), 1)
                    ]),
                _: 1
            }, 8, [
                "onClick"
            ]),
            $data.package.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives((_openBlock(), _createBlock(_component_scTable, {
                    ref: "table",
                    data: $options.pagedPackage,
                    staticTotal: $data.package.length,
                    pageSize: $data.pageSize,
                    pageNo: $data.pageNo,
                    width: "600px",
                    stripe: "",
                    border: "",
                    showFlex: false,
                    hideDo: "",
                    "row-key": "id",
                    onPaginationChange: $options.handlePageChange,
                    onPageSizeChange: $options.handlePageSizeChange
                }, {
                    default: _withCtx(()=>[
                            _createVNode(_component_el_table_column, {
                                label: "序号",
                                type: "index",
                                width: "120",
                                align: "center"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "类型",
                                prop: "supplier.title",
                                width: "120",
                                align: "center"
                            }, {
                                default: _withCtx(({ row })=>[
                                        _createElementVNode("div", null, _toDisplayString($options.selectType(row.type)), 1)
                                    ]),
                                _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "产品",
                                prop: "title",
                                align: "center",
                                "min-width": "150"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "操作",
                                fixed: "right",
                                align: "center",
                                width: "120"
                            }, {
                                default: _withCtx(({ row, $index })=>[
                                        _createVNode(_component_el_button_group, null, {
                                            default: _withCtx(()=>[
                                                    _createVNode(_component_el_button, {
                                                        link: "",
                                                        type: "primary",
                                                        size: "small",
                                                        onClick: ($event)=>$options.deleteData(row, $index)
                                                    }, {
                                                        default: _withCtx(()=>[
                                                                ..._cache[2] || (_cache[2] = [
                                                                    _createTextVNode("取消选择", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    }, 8, [
                                                        "onClick"
                                                    ])
                                                ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                }, 8, [
                    "data",
                    "staticTotal",
                    "pageSize",
                    "pageNo",
                    "onPaginationChange",
                    "onPageSizeChange"
                ])), [
                    [
                        _directive_loading,
                        _ctx.isLoading
                    ]
                ])
            ])) : _createCommentVNode("", true)
        ]),
        $data.visible ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            ref: "Dialog",
            modelValue: $data.url,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.url = $event),
            onSubmit: $options.submit,
            onClosed: _cache[1] || (_cache[1] = ($event)=>$data.visible = false)
        }, null, 8, [
            "modelValue",
            "onSubmit"
        ])) : _createCommentVNode("", true)
    ], 64);
}
